import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/services/toast.service';
import { GameService } from 'src/app/services/game.service';
import { isValidGameIdentifier, isValidGamePrice } from 'src/app/utilities/game-validation';
import { GAME_LANG_CODES, GAME_LANG_MAP as LANG_MAP } from 'src/app/utilities/game-languages';

// Languages checked by default when creating a game
const DEFAULT_LANGS = ['nl', 'en', 'es'];

@Component({
  selector: 'app-create-game',
  templateUrl: './create-game.component.html',
  styleUrls: ['./create-game.component.scss'],
})
export class CreateGameComponent {
  @Input() selfModal: NgbModalRef | null = null;

  faTimes = faTimes;
  faCircleNorch: any = faCircleNotch;
  loadSpin: boolean = false;

  readonly langCodes = GAME_LANG_CODES;
  languages: Record<string, boolean> = Object.fromEntries(
    GAME_LANG_CODES.map(c => [c, DEFAULT_LANGS.includes(c)])
  );

  form: any = {
    identifier: '',
    type: '',
    price: '',
    free_sample: true,
    active: true,
  };

  readonly typeOptions = ['grid', 'archetypes'];

  constructor(
    private gameService: GameService,
    private toastService: ToastService,
    private translate: TranslateService,
    private router: Router,
  ) {}

  closeModal() {
    if (this.selfModal) this.selfModal?.close();
    else $('ngb-modal-window').click();
  }

  get activeTabs(): string[] {
    return Object.entries(this.languages)
      .filter(([, active]) => active)
      .map(([lang]) => lang);
  }

  get identifierInvalid(): boolean {
    return this.form.identifier !== '' && !isValidGameIdentifier(this.form.identifier);
  }

  get priceInvalid(): boolean {
    return this.form.price !== '' && this.form.price !== null && !isValidGamePrice(this.form.price);
  }

  isValid(): boolean {
    return (
      isValidGameIdentifier(this.form.identifier) &&
      this.activeTabs.length > 0 &&
      this.form.type !== '' &&
      isValidGamePrice(this.form.price)
    );
  }

  private buildPayload() {
    const data_json: any = {};
    Object.entries(LANG_MAP).forEach(([code, langKey]) => {
      if (this.languages[code]) {
        data_json[langKey] = { name: '', description: '' };
      }
    });
    return {
      identifier: this.form.identifier,
      type: this.form.type,
      price: this.form.price ? Number(this.form.price) : null,
      free_sample: this.form.free_sample,
      active: this.form.active,
      data_json,
    };
  }

  save() {
    this.loadSpin = true;
    this.gameService.createGame(this.buildPayload())
      .then((resp: any) => {
        this.loadSpin = false;
        this.toastService.showSuccess(this.translate.instant('game:create:success'));
        this.closeModal();
        const newId = resp?.data?.id ?? resp?.id;
        if (newId) this.router.navigate(['/admin/game/edit', newId]);
      })
      .catch(() => {
        this.loadSpin = false;
        this.toastService.showError(this.translate.instant('game:create:error'));
      });
  }
}
